import TpJobAdmin from './TpJobAdmin';

export default class FinalizedTpJobsAdmin extends TpJobAdmin {}
